import { ArrayUnique, IsArray, IsOptional, IsString, IsUrl, Matches, MaxLength } from 'class-validator';

export class CreateApplicationDto {
  // Becomes the appId a consuming product passes to ChatWidget.init() — kept
  // URL/config-safe on purpose.
  @IsString()
  @MaxLength(64)
  @Matches(/^[a-z0-9][a-z0-9-]*$/, { message: 'slug must be lowercase letters, numbers and hyphens only' })
  slug!: string;

  @IsString()
  @MaxLength(120)
  name!: string;

  @IsOptional()
  @IsArray()
  @ArrayUnique()
  @IsUrl({ require_tld: false }, { each: true })
  allowedOrigins?: string[];
}
